/* LVC premium : personnalisation en étapes (prénom puis style) avec aperçu, prix dans le bouton, avis repliés, livraison offerte mise à jour après ajout au panier */
(function () {
  /* Aperçu fidèle : lettres de l'outil Prénoms Silhouette (accents recomposés, F et f corrigés, & remplacé) pour le style 1 */
  var GLURL = (document.currentScript && document.currentScript.src) ? document.currentScript.src.replace(/lvc-premium\.js/, 'lvc-glyphes.json') : '';
  var GL = null;
  function loadGL(done) {
    if (!GLURL || !window.fetch) return;
    fetch(GLURL).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) { if (d && d.styles) { GL = d; done(); } }).catch(function () {});
  }
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function fit(el) {
    el.style.removeProperty('font-size');
    var cw = el.clientWidth; if (!cw) return;
    var sw = el.scrollWidth;
    if (sw > cw * 0.86) {
      var fs = parseFloat(getComputedStyle(el).fontSize);
      el.style.setProperty('font-size', Math.max(9, fs * cw * 0.86 / sw) + 'px', 'important');
    }
  }
  function fitAll() { document.querySelectorAll('.lvcp-style__name, .lvcp-plate__n').forEach(fit); }
  window.addEventListener('resize', fitAll);
  function paint(el, text, cls) {
    var set = GL && cls === 'f1' ? GL.styles['1'] : null;
    if (!set) { el.textContent = text; return; }
    var s = text.normalize ? text.normalize('NFC') : text;
    var ex = GL.noms && GL.noms['1|' + s.trim()];
    if (ex) {
      el.innerHTML = '<svg class="lvcp-gl" role="img" aria-label="' + esc(s) + '" viewBox="' + ex.x + ' -230 ' + ex.w + ' 310" width="' + (ex.w / 250) + 'em" height="1.24em"><path d="' + ex.p + '"/></svg>';
      return;
    }
    var html = '', hit = false;
    for (var i = 0; i < s.length; i++) {
      var ch = s.charAt(i), g = set[ch + '>' + s.charAt(i + 1).toLowerCase()] || set[ch]; /* variante « accent suivi de telle lettre » apprise par l'outil */
      if (g) { hit = true; html += '<svg class="lvcp-gl" aria-hidden="true" viewBox="0 -230 ' + g.a + ' 310" width="' + (g.a / 250) + 'em" height="1.24em"><path d="' + g.p + '"/></svg>'; }
      else html += esc(ch);
    }
    if (hit) { el.innerHTML = html; el.setAttribute('aria-label', text); }
    else el.textContent = text;
  }
  var FONTS = 'https://fonts.googleapis.com/css2?family=Arizonia&family=Noto+Naskh+Arabic:wght@500&display=swap';
  var NIB = '<svg class="lvc-pi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21.5 7 11.2 12 2.5l5 8.7z"/><path d="M12 2.5v9"/><circle cx="12" cy="12.8" r="1.3"/><path d="M8.8 17.6h6.4" stroke-width="1.1"/></svg>';
  var CHECK = '<svg class="lvc-pi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.2"/><path d="m8 12.4 2.8 2.8L16.2 9.6"/></svg>';

  function styleClass(v) {
    v = (v || '').toLowerCase();
    if (v.indexOf('arabe') > -1) return 'fa';
    var m = v.match(/style\s*(\d)/);
    return m ? 'f' + m[1] : 'f4';
  }
  function isArabic(s) { return /[؀-ۿ]/.test(s); }
  function fieldOf(el) { return el.closest('[class*="spb-io-field"]') || el.parentNode; }

  function enhance(root) {
    if ((document.body.getAttribute('data-tpl') || '').indexOf('affiche') > -1) return; /* les affiches ont leur propre script */
    var box = root.querySelector('#infiniteoptions-container');
    if (!box || box.dataset.lvcp) return;
    var sel = box.querySelector('select[name*="Style"], select[name*="style"], select[name*="criture"]');
    var nameInput = box.querySelector('input[type="text"]');
    if (!sel || !nameInput) return;
    box.dataset.lvcp = '1';
    if (!document.getElementById('lvcp-fonts')) {
      var l = document.createElement('link'); l.id = 'lvcp-fonts'; l.rel = 'stylesheet'; l.href = FONTS; document.head.appendChild(l);
    }
    var head = document.createElement('div');
    head.className = 'lvcp-perso-h';
    head.innerHTML = NIB + '<strong>Votre personnalisation</strong>';
    var ARGENT = /enfant/.test(document.body.getAttribute('data-pdt') || '');
    if (ARGENT) {
      var ag = document.createElement('p');
      ag.className = 'lvcp-argent';
      ag.innerHTML = '<i aria-hidden="true"></i><span>Prénom inscrit en <strong>écriture argentée</strong> sur la veilleuse</span>';
      head.appendChild(ag);
    }
    box.parentNode.insertBefore(head, box);

    var fName = fieldOf(nameInput), fStyle = fieldOf(sel);
    box.insertBefore(fName, fStyle); /* le prénom d'abord, le style ensuite */

    function setOpen(f, o) {
      f.classList.toggle('is-open', o);
      var h = f.querySelector('.lvcp-st__h');
      if (h) h.setAttribute('aria-expanded', o ? 'true' : 'false');
      setTimeout(fitAll, 60);
    }
    function mkStep(field, n, title, open) {
      field.classList.add('lvcp-st');
      var h = document.createElement('button');
      h.type = 'button';
      h.className = 'lvcp-st__h';
      h.innerHTML = '<span class="lvcp-st__n">' + n + '</span><span class="lvcp-st__t">' + title + '</span><span class="lvcp-st__v"></span><span class="lvcp-st__chev" aria-hidden="true"></span>';
      h.addEventListener('click', function () { setOpen(field, !field.classList.contains('is-open')); });
      field.insertBefore(h, field.firstChild);
      var body = field.querySelector('.spb-option-values') || field.lastElementChild;
      body.classList.add('lvcp-st__b');
      setOpen(field, open);
      return { f: field, b: body, v: h.querySelector('.lvcp-st__v') };
    }
    var s1 = mkStep(fName, 1, 'Le prénom', true);
    var s2 = mkStep(fStyle, 2, "Le style d'écriture", false);

    var plate = document.createElement('div');
    plate.className = 'lvcp-plate is-empty';
    plate.innerHTML = '<small>' + (ARGENT ? 'Aper\u00e7u \u00b7 \u00e9criture argent\u00e9e' : 'Aper\u00e7u') + '</small><span class="lvcp-plate__n"></span>';
    s1.b.insertBefore(plate, s1.b.firstChild);
    nameInput.setAttribute('placeholder', 'Écrivez le prénom');
    nameInput.setAttribute('autocomplete', 'off');
    var help = document.createElement('p');
    help.className = 'lvcp-note';
    help.textContent = "Il s’agit d’un aperçu : si une lettre ou un tréma vous semble incorrect, pas d’inquiétude, nous ajustons manuellement chaque prénom afin de garantir le meilleur rendu esthétique. Pour un prénom en arabe, écrivez-le directement en lettres arabes.";
    s1.b.appendChild(help);

    var wrap = sel.closest('.spb-select') || sel;
    wrap.classList.add('lvcp-io-hidden');
    var grid = document.createElement('div');
    grid.className = 'lvcp-styles';
    grid.setAttribute('role', 'radiogroup');
    var tiles = [];
    Array.prototype.forEach.call(sel.options, function (o) {
      if (!o.value) return;
      var cls = styleClass(o.value);
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'lvcp-style' + (cls === 'fa' ? ' lvcp-style--wide' : '');
      t.setAttribute('role', 'radio');
      t.dataset.value = o.value;
      t.dataset.cls = cls;
      var lab = cls === 'fa' ? 'Arabe' : o.value.trim();
      t.innerHTML = '<span class="lvcp-style__name lvcp-' + cls + '"></span><span class="lvcp-style__lab">' + lab + '</span>';
      t.addEventListener('click', function () { pick(o.value); });
      grid.appendChild(t);
      tiles.push(t);
    });
    s2.b.appendChild(grid);
    var note = document.createElement('p');
    note.className = 'lvcp-note';
    note.textContent = 'Aperçu indicatif : le rendu final peut varier légèrement.';
    s2.b.appendChild(note);

    function pick(v) {
      sel.value = v;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
    }
    function current() {
      for (var i = 0; i < tiles.length; i++) if (tiles[i].dataset.value === sel.value) return tiles[i];
      return null;
    }
    function sync() {
      var v = nameInput.value.trim();
      var cur = current();
      var cls = cur ? cur.dataset.cls : 'f1';
      tiles.forEach(function (t) {
        var on = t === cur;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        var n = t.querySelector('.lvcp-style__name');
        if (t.dataset.cls === 'fa') n.textContent = v && isArabic(v) ? v : 'مريم';
        else paint(n, v && !isArabic(v) ? v : 'Adam', t.dataset.cls);
      });
      var pn = plate.querySelector('.lvcp-plate__n');
      pn.className = 'lvcp-plate__n lvcp-' + cls;
      if (cls === 'fa') pn.textContent = v && isArabic(v) ? v : 'مريم';
      else paint(pn, v && !isArabic(v) ? v : 'Adam', cls);
      plate.classList.toggle('is-empty', !v);
      s1.v.textContent = v;
      s1.f.classList.toggle('is-done', !!v);
      s2.v.textContent = cur ? (cls === 'fa' ? 'Arabe' : cur.dataset.value.trim()) : '';
      s2.f.classList.toggle('is-done', !!cur);
      fitAll();
    }
    var opened2 = false;
    nameInput.addEventListener('input', function () {
      var v = nameInput.value.trim();
      if (v && isArabic(v)) {
        var cur = current();
        if (!cur || cur.dataset.cls !== 'fa') tiles.forEach(function (t) { if (t.dataset.cls === 'fa') pick(t.dataset.value); });
      }
      if (v && !opened2) { opened2 = true; setOpen(fStyle, true); }
      sync();
    });
    nameInput.addEventListener('invalid', function () { setOpen(fName, true); });
    sel.addEventListener('invalid', function () { setOpen(fStyle, true); });
    sel.addEventListener('change', sync);
    sync();
    loadGL(sync);
  }

  function ctaPrice() {
    document.querySelectorAll('.product-form__submit').forEach(function (b) {
      var info = b.closest('.product__info-container') || document;
      var p = info.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular');
      var span = b.querySelector('span');
      if (!p || !span || b.querySelector('.lvcp-cta-price') || b.disabled) return;
      var s = document.createElement('span');
      s.className = 'lvcp-cta-price';
      s.textContent = p.textContent.trim();
      span.appendChild(s);
    });
  }

  function reviews() {
    if (location.pathname.indexOf('/products/') < 0) return;
    var r = document.querySelector('[id$="__reviews"] .loox-reviews-default');
    if (!r || r.dataset.lvcp) return;
    var h = r.getBoundingClientRect().height;
    if (h < 1300) return;
    r.dataset.lvcp = '1';
    r.classList.add('lvcp-rv-clip');
    var more = document.createElement('div');
    more.className = 'lvcp-rv-more';
    more.innerHTML = '<button type="button">Lire tous les avis</button>';
    more.querySelector('button').addEventListener('click', function () { r.classList.remove('lvcp-rv-clip'); more.remove(); });
    r.parentNode.insertBefore(more, r.nextSibling);
  }

  /* Livraison offerte : la barre de la fiche se met à jour dès l'ajout au panier */
  function money(c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
  function shipRefresh() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.lvcp-deliv[data-threshold]').forEach(function (d) {
        var th = Number(d.dataset.threshold) * 100;
        var rem = th - c.total_price;
        var pct = Math.max(4, Math.min(100, Math.round(c.total_price * 100 / th)));
        var bar = d.querySelector('.lvcp-bar');
        if (!bar) return;
        d.classList.toggle('is-done', rem <= 0);
        d.dataset.added = '1';
        bar.innerHTML = rem > 0
          ? '<span>' + CHECK + ' Ajouté au panier · plus que <b>' + money(rem) + '</b> pour la livraison offerte en point relais</span><div class="lvcp-bar__track" aria-hidden="true"><i style="width:' + pct + '%"></i></div>'
          : '<span>' + CHECK + ' Livraison offerte en point relais sur votre panier</span>';
        bar.classList.remove('is-flash'); void bar.offsetWidth; bar.classList.add('is-flash');
      });
    }).catch(function () {});
  }
  var subscribed = false;
  function subscribeCart() {
    if (subscribed || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribed = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(shipRefresh, 150); });
  }

  
  /* Traduction française des messages de l'application d'options de personnalisation */
  var TR_FR = [
    ['Please add your personalized text before adding this item to cart.', 'Veuillez saisir votre texte personnalis\u00e9 avant d\u2019ajouter cet article au panier.'],
    ['Please select your options before adding this item to cart', 'Veuillez choisir vos options avant d\u2019ajouter cet article au panier.'],
    ['Please select an option before adding this item to cart', 'Veuillez choisir une option avant d\u2019ajouter cet article au panier.'],
    ['Please enter a number before adding this item to cart', 'Veuillez saisir un nombre avant d\u2019ajouter cet article au panier.'],
    ['Please turn on the required option before adding this item to cart', 'Veuillez activer l\u2019option requise avant d\u2019ajouter cet article au panier.'],
    ['Please select a date before adding this item to cart.', 'Veuillez choisir une date avant d\u2019ajouter cet article au panier.'],
    ['Please upload a file before adding this item to cart.', 'Veuillez importer un fichier avant d\u2019ajouter cet article au panier.'],
    ['This product cannot be purchased using this checkout method. Please add the item to cart, then proceed to checkout from the cart.', 'Ce produit ne peut pas \u00eatre achet\u00e9 avec ce mode de paiement. Ajoutez-le au panier, puis passez la commande depuis le panier.'],
    ['Characters remaining', 'caract\u00e8res restants']
  ];
  function tradFr(root) {
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) { if (n.nodeValue && n.nodeValue.indexOf('Please') > -1 || n.nodeValue && n.nodeValue.indexOf('Characters remaining') > -1 || n.nodeValue && n.nodeValue.indexOf('This product cannot') > -1) list.push(n); }
    list.forEach(function (t) { TR_FR.forEach(function (p) { if (t.nodeValue.indexOf(p[0]) > -1) t.nodeValue = t.nodeValue.replace(p[0], p[1]); }); });
  }
  var trTimer;
  new MutationObserver(function () { clearTimeout(trTimer); trTimer = setTimeout(function () { tradFr(); }, 30); })
    .observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  
  /* Messages de l'application d'options : traduits en français (l'app les affiche en anglais par défaut) */
  function trStrings() {
    var io = window.Shoppad && Shoppad.apps && Shoppad.apps.infiniteoptions;
    if (!io || !io.strings || !io.strings.errorMessages) return;
    var m = io.strings.errorMessages;
    m.forTextInputs = 'Veuillez saisir votre texte personnalis\u00e9 avant d\u2019ajouter cet article au panier.';
    m.forNumberInputs = 'Veuillez saisir un nombre avant d\u2019ajouter cet article au panier.';
    m.forCheckboxes = 'Veuillez choisir vos options avant d\u2019ajouter cet article au panier.';
    m.forSwitches = 'Veuillez activer l\u2019option requise avant d\u2019ajouter cet article au panier.';
    m.forMinimumValues = 'Veuillez choisir au moins %valuesmin options avant d\u2019ajouter cet article au panier.';
    m.forDateInputs = 'Veuillez choisir une date avant d\u2019ajouter cet article au panier.';
    m.forFileInputs = 'Veuillez importer un fichier avant d\u2019ajouter cet article au panier.';
    m.forFileStillUploading = 'Veuillez patienter jusqu\u2019\u00e0 la fin de l\u2019envoi de votre fichier.';
    m.forFileTooLarge = 'Ce fichier est trop volumineux. Choisissez un fichier de moins de %maxfilesize.';
    m.forFileType = 'Ce type de fichier n\u2019est pas accept\u00e9.';
    m.forFileUploadFailed = 'Un probl\u00e8me est survenu pendant l\u2019envoi du fichier. Veuillez r\u00e9essayer.';
    m.forDropdowns = 'Veuillez choisir une option avant d\u2019ajouter cet article au panier.';
    m.forDynamicCheckout = 'Ce produit ne peut pas \u00eatre achet\u00e9 avec ce mode de paiement. Ajoutez-le au panier, puis passez la commande depuis le panier.';
    io.strings.charactersRemaining = 'caract\u00e8res restants';
  }
  function motNote() {
    if (location.pathname.indexOf('/products/') < 0) return;
    var b = document.querySelector('.product-form__buttons');
    if (!b || document.querySelector('.lvcp-mot-note')) return;
    var p = document.createElement('p');
    p.className = 'lvcp-mot-note';
    p.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5.5" width="18" height="13" rx="2.4"/><path d="m3.8 7.4 8.2 6.2 8.2-6.2"/></svg><span><strong>Un petit mot pour le destinataire ?</strong> Vous pourrez l\u2019\u00e9crire dans votre panier, nous le glisserons dans le colis.</span>';
    b.parentNode.insertBefore(p, b.nextSibling);
  }
  function run() { enhance(document); trStrings(); ctaPrice(); motNote(); reviews(); subscribeCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var n = 0, iv = setInterval(function () { run(); if (++n > 40) clearInterval(iv); }, 500);
})();
